module.exports = __webpack_public_path__ + "static/media/3.5205ceba.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/gifs/3.gif
// module id = 244
// module chunks = 0